import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";
import Button from "../../../button/Button";
import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";

interface IProps {
    setDestError: (data) => void;
    destError;
}

const DestError = (props: IProps) => {
    const { t } = useTranslation();

    return (
        <Modal
            aria-labelledby="contained-modal-title-vcenter"
            centered
            onHide={() => props.setDestError(null)}
            show={!!props.destError}
        >
            <Modal.Header>
                <div>
                    <FontAwesomeIcon
                        icon={faTriangleExclamation}
                        style={{ color: "var(--userful-alert)", marginRight: "8px" }}
                    />
                    {t("CommonUI.MappingGroups.destError")}
                </div>
                <div className="custom-close-btn" onClick={() => props.setDestError(null)}>
                    <FontAwesomeIcon icon={faClose} />
                </div>
            </Modal.Header>
            <Modal.Body>{props.destError}</Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => props.setDestError(null)}>
                    {t("Shared.ok")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DestError;
